// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I7lMNZHp9E41DQnA5h64 {
	display: flex;
	flex-direction: column;
}
.DA_NU_jt6HjDwUDKkqcA {
	color: #000000;
	letter-spacing: -0.04em;
	margin-bottom: 15px;
	text-transform: uppercase;
	text-transform: uppercase;
}
.r3jGFXidoZaVNIZLOHb4 {
	align-items: center;
	display: flex;
	height: 44px;
	margin-bottom: 20px;
	justify-content: space-between;
	gap: 8px;
}
.piUAp4H8p5fhDz4dWEDS {
	margin: 16px 0 30px;
}
.GGqlO5in_IcodLd1INV_ {
	margin: 6px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPageV2/TotalRewardsBalance.pcss"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AAEA;CACC,cAAc;CACd,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;AAC1B;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,QAAQ;AACT;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;AAChB","sourcesContent":["@import '../../stylesheets/media-queries.pcss';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.title {\n\tcolor: #000000;\n\tletter-spacing: -0.04em;\n\tmargin-bottom: 15px;\n\ttext-transform: uppercase;\n\ttext-transform: uppercase;\n}\n\n.available {\n\talign-items: center;\n\tdisplay: flex;\n\theight: 44px;\n\tmargin-bottom: 20px;\n\tjustify-content: space-between;\n\tgap: 8px;\n}\n\n.details {\n\tmargin: 16px 0 30px;\n}\n\n.spinner {\n\tmargin: 6px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `I7lMNZHp9E41DQnA5h64`,
	"title": `DA_NU_jt6HjDwUDKkqcA`,
	"available": `r3jGFXidoZaVNIZLOHb4`,
	"details": `piUAp4H8p5fhDz4dWEDS`,
	"spinner": `GGqlO5in_IcodLd1INV_`
};
export default ___CSS_LOADER_EXPORT___;
